import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { AiOutlinePlus } from "react-icons/ai";
import { BiMinus } from "react-icons/bi";
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { addToCart, detrimentQNT, incrementQNT } from '../../features/cartProducts/cartSlice';

const Card = ({ product }) => {

    const { productId } = useParams();
    const { name, description, price, prvPrice, descriptionBN } = product;

    const { cartProducts } = useSelector((state) => state.cartProducts);
    const cartproduct = cartProducts.find((item) => item._id === productId);

    const dispatch = useDispatch();

    const handleAddToCart = () => {
        dispatch(addToCart(product))
    }
    const handleIncrementQNT = () => {
        dispatch(incrementQNT(product))
    }
    const handleDetrimentQNT = () => {
        dispatch(detrimentQNT(product))
    }


    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);


    return (
        <div>
            <div>
                <h3 className='text-2xl font-poppins pb-2'>{name.length > 100 ? name.substring(100, 0) + ".." : name}</h3>

                {translate ?
                    <div dangerouslySetInnerHTML={{ __html: description }} />
                    :
                    (product?.descriptionBN === '' ?
                        <div dangerouslySetInnerHTML={{ __html: description }} />
                        :
                        <div dangerouslySetInnerHTML={{ __html: descriptionBN }} />
                    )
                }
                <div className='pt-4 px-2'>
                    <p className='text-lg font-semibold font-poppins space-x-2'>
                        <span className='text-redbnd line-through'>
                            {Number(price) < Number(prvPrice) && (prvPrice + " BDT")}
                        </span>
                        <span className=''>
                            {price} BDT
                        </span>
                    </p>
                </div>
                <div className='input-arrw-none w-full grid content-center justify-center select-none'>
                    <div className="flex flex-wrap items-stretch w-32 mb-4 pt-2 relative">
                        <div className="flex -mr-px">
                            <span onClick={handleDetrimentQNT} className="w-11 hover:bg-bnd-1 hover:text-white cursor-pointer duration-300 grid content-center justify-center leading-normal bg-grey-lighter rounded-l border border-r-0 px-1 border-grey-light whitespace-no-wrap">
                                <BiMinus className='text-xm' />
                            </span>
                        </div>
                        <input type="number" value={cartproduct?.quantity ? cartproduct?.quantity : 1} className="font-poppins font-medium outline-none bg-gray-100 flex-shrink flex-grow leading-normal w-px border h-10 border-grey-light text-center relative" />
                        <div className="flex -mr-px">
                            <span onClick={handleIncrementQNT} className="w-11 hover:bg-bnd-1 hover:text-white cursor-pointer duration-300 grid content-center justify-center leading-normal bg-grey-lighter rounded-r border border-l-0 border-grey-light px-2 whitespace-no-wrap">
                                <AiOutlinePlus className='text-sm' />
                            </span>
                        </div>
                    </div>
                </div>
                <div className=" w-full grid content-center justify-center">
                    <button onClick={handleAddToCart} className='w-38 bg-bnd-1 text-white  text-md font-medium add-cart-btn rounded-full uppercase'>add to cart</button>
                </div>
            </div>
            <div></div>
        </div>
    );
};

export default Card;